import React from "react";
import firebase from "firebase/compat/app";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
function Paginationbutton({ page, list, setList, setPage, col, selected }) {
  let field;
  let sorting;

  const showNext = ({ item }) => {
    if (selected == 0) {
      field = "price";
      sorting = "asc";
    }
    if (selected == 1) {
      field = "price";
      sorting = "asc";
    }
    if (selected == 2) {
      field = "price";
      sorting = "desc";
    }

    const fetchNextData = async () => {
      await firebase
        .firestore()
        .collection(col)
        .orderBy(field, sorting)
        .limit(8)
        .startAfter(item.price)
        .onSnapshot(function (querySnapshot) {
          const items = [];
          querySnapshot.forEach(function (doc) {
            items.push({ key: doc.id, ...doc.data() });
          });

          setList(items);
          setPage(page + 1);
        });
    };
    fetchNextData();

    if (selected == 3) {
      const fectchingOnsales = async () => {
        await firebase
          .firestore()
          .collection(col)
          .where("onsales", "==", "best price")
          .orderBy("price", "desc")
          .limit(8)
          .startAfter(item.price)
          .onSnapshot(function (querySnapshot) {
            const items = [];
            querySnapshot.forEach(function (doc) {
              items.push({ key: doc.id, ...doc.data() });
            });

            setList(items);
            setPage(page + 1);
          });
      };
      fectchingOnsales();
    }
  };
  const showPrevious = ({ item }) => {
    if (selected == 0) {
      field = "price";
      sorting = "asc";
    }
    if (selected == 1) {
      field = "price";
      sorting = "asc";
    }
    if (selected == 2) {
      field = "price";
      sorting = "desc";
    }

    const fetchPreviousData = async () => {
      await firebase
        .firestore()
        .collection(col)
        .orderBy(field, sorting)
        .endBefore(item.price)
        .limitToLast(8)
        .onSnapshot(function (querySnapshot) {
          const items = [];
          querySnapshot.forEach(function (doc) {
            items.push({ key: doc.id, ...doc.data() });
          });

          setList(items);
          setPage(page - 1);
        });
    };
    fetchPreviousData();
    if (selected == 3) {
      const fectchingOnsales = async () => {
        await firebase
          .firestore()
          .collection(col)
          .where("onsales", "==", "best price")
          .orderBy("price", "desc")
          .endBefore(item.price)
          .limitToLast(8)
          .onSnapshot(function (querySnapshot) {
            const items = [];
            querySnapshot.forEach(function (doc) {
              items.push({ key: doc.id, ...doc.data() });
            });

            setList(items);
            setPage(page - 1);
          });
      };
      fectchingOnsales();
    }
  };

  return (
    <div className="pagination__container">
      {
        //show previous button only when we have items
        page === 1 ? (
          ""
        ) : (
          <button
            className="pagination__button"
            onClick={() => showPrevious({ item: list[0] })}
          >
            <ArrowBackIosNewIcon />
          </button>
        )
      }
      {
        //show next button only when we have items
        list.length < 8 ? (
          ""
        ) : (
          <button
            className="pagination__button"
            onClick={() => showNext({ item: list[list.length - 1] })}
          >
            <ArrowForwardIosIcon className="pagination__icon" />
          </button>
        )
      }
    </div>
  );
}

export default Paginationbutton;
